<script>
import cloneDeep from "lodash/cloneDeep";
import { MapGender, MapRoles } from "@/common/util";

export default {
  data() {
    return {
      tableData: [],
      textInputArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId"
        // },
        {
          label: "姓名",
          keyName: "name"
        },
        {
          label: "手机号",
          keyName: "phone"
        }
      ],
      selectInputArray: [
        {
          label: "角色",
          keyName: "role",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "超级管理员",
              keyName: "ROLE_SUPER_ADMIN"
            },
            {
              label: "大区经理",
              keyName: "ROLE_REGION_MANAGER"
            },
            // {
            //   label: "视光师",
            //   keyName: "ROLE_AGENT_OPTOMETRIST"
            // },
            {
              label: "广目视觉训练师",
              keyName: "ROLE_GROUP_OPTOMETRIST"
            }
            // {
            //   label: "代理商",
            //   keyName: "ROLE_AGENT"
            // },
            // {
            //   label: "医生",
            //   keyName: "ROLE_DOCTOR"
            // }
          ]
        }
      ],
      resetPasswordArray: [
        {
          label: "手机号",
          keyName: "phone",
          type: "text",
          isDisable: true
        },
        {
          label: "本账户密码",
          keyName: "password",
          type: "password",
          placeholder: "请输入您的登录密码进行验证。"
        }
        // {
        //   label: "",
        //   keyName: "alert",
        //   type: "alert",
        //   alertContent: "系统将自动生成密码并发送到用户的手机"
        // }
      ],
      resetPasswordAlert: "系统将自动生成密码并发送到用户的手机",
      addAccountForm: [
        // {
        //   label: "工号",
        //   keyName: "staffId",
        //   type: "text"
        // },
        {
          label: "姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "手机号",
          keyName: "phone",
          type: "text"
        },
        {
          label: "职务",
          keyName: "role",
          type: "select",
          children: [
            {
              label: "超级管理员",
              keyName: "ROLE_SUPER_ADMIN"
            },
            {
              label: "大区经理",
              keyName: "ROLE_REGION_MANAGER"
            },
            {
              label: "广目视觉训练师",
              keyName: "ROLE_GROUP_OPTOMETRIST"
            }
          ]
        }
      ],
      addingUser: false,
      resetPassword: false,
      editUser: false,
      deleteUser: false,
      stopUser: false,
      buttonArray: [
        {
          text: "编辑",
          key: "edit"
        },
        {
          text: "重置密码",
          key: "reset"
        },
        {
          text: "停用",
          key: "stop"
        },
        {
          text: "删除",
          key: "delete"
        }
      ],
      searchFormData: {
        staffId: "",
        name: "",
        phone: "",
        role: ""
      },
      defaultValue: {},
      totalElements: 0
    };
  },

  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {};
      for (let key in this.searchFormData) {
        if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      let data = await this.$http.getGroupAcountList(params);
      if (data && data.content) {
        let newTableData = [];
        data.content.forEach(item => {
          console.log("-->>>", item.roles[0]);
          this.totalElements = data.totalElements;
          newTableData.push({
            id: item.content.id,
            staffId: item.content.staffId,
            name: item.content.name,
            phone: item.content.phone,
            gender: MapGender(item.content.gender),
            role: MapRoles(item.roles[0])
          });
        });
        this.tableData = newTableData;
      }
    },
    onSearch(data) {
      this.searchFormData = data;
      this.loadData();
    },
    async onUpdateAccount(formdata, type, row) {
      if (type === "editAccount") {
        const updateData = cloneDeep(formdata);
        updateData.userId = row.id;
        updateData.oldRole = MapRoles(row.role);
        let result = await this.$http.updateAcountInfo(type, updateData);
      } else if (type === "resetAccount") {
        const pwd = formdata.password;
        let result = await this.$http.checkAdminPwd(pwd);
        if (result == "success") {
          const updateData = {
            userId: row.id,
            resetPassword: true
          };
          let result = await this.$http.updateAcountInfo(type, updateData);
          if (result) {
            this.$message.success("重置成功");
            this.resetPassword = false;
          }
        } else {
          this.$message.warning("密码错误，请重新输入密码");
        }
      } else if (type === "stopAccount") {
        const updateData = {
          userId: row.id,
          enabled: false
        };
        let result = await this.$http.updateAcountInfo(type, updateData);
      } else if (type === "deleteAccount") {
        let result = await this.$http.updateAcountInfo(type, row.id);
      } else if (type === "addAccount") {
        const updateData = cloneDeep(formdata);
        let result = await this.$http.updateAcountInfo(type, updateData);
      }
      this.loadData();
      this.defaultValue = {};
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      switch (key) {
        case "edit":
          this.editUser = true;
          break;
        case "reset":
          this.resetPassword = true;
          break;
        case "stop":
          this.stopUser = true;
          break;
        case "delete":
          this.deleteUser = true;
          break;
      }
    },
    onClickCancel(key, afterSubmit) {
      this.defaultValue = {};
      switch (key) {
        case "editAccount":
          this.editUser = false;
          break;
        case "resetAccount":
          if (afterSubmit !== "afterSubmit") {
            this.resetPassword = false;
          }
          break;
        case "stopAccount":
          this.stopUser = false;
          break;
        case "deleteAccount":
          this.deleteUser = false;
          break;
      }
    }
  }
};
</script>
<template>
  <div class="groupAccountIndex">
    <DialogForm
      v-if="addingUser"
      formTitle="添加账号"
      :formInputArray="addAccountForm"
      @close="addingUser = false"
      @submitForm="onUpdateAccount"
      keyOperation="addAccount"
    />
    <DialogForm
      v-if="resetPassword"
      formTitle="重置密码"
      :defaultValue="defaultValue"
      :formInputArray="resetPasswordArray"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="resetAccount"
      :alertItem="resetPasswordAlert"
    />
    <DialogForm
      v-if="editUser"
      :defaultValue="defaultValue"
      formTitle="编辑账号"
      :formInputArray="addAccountForm"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="editAccount"
    />
    <DialogForm
      v-if="stopUser"
      :defaultValue="defaultValue"
      formTitle="请确认停用账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="stopAccount"
      confirmButton="确认"
    />
    <DialogForm
      v-if="deleteUser"
      :defaultValue="defaultValue"
      formTitle="请确认删除账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="deleteAccount"
      confirmButton="确认"
    />

    <searchForm
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      :textInputArray="textInputArray"
      :selectInputArray="selectInputArray"
    />
    <elementButton class="addBtn" @click="addingUser = true">添加账号</elementButton>
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="accountTable"
      row-class-name="row_class"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <!-- <el-table-column prop="staffId" align="left" label="工号" width="150"></el-table-column> -->
      <el-table-column prop="name" align="left" label="姓名" min-width="150"></el-table-column>
      <el-table-column prop="gender" align="left" label="性别" width="100"></el-table-column>
      <el-table-column prop="phone" align="left" label="手机号" width="150"></el-table-column>
      <el-table-column prop="role" align="left" label="角色" min-width="120"></el-table-column>
      <el-table-column prop="operation" align="left" label="操作" min-width="220">
        <template slot-scope="scope">
          <textButtonGroup
            :buttonArray="buttonArray"
            :rowData="scope.row"
            @onOperationClick="onOperationClick"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";
.groupAccountIndex {
  .line {
    width: auto;
    height: 1px;
    background-color: #ebebeb;
    margin: 10px;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .searchForm {
    border: 1px;
    height: 70px;
    margin: 0 2%;
  }

  .labelStyle1 {
    margin: 20px 5px 10px;
    width: 200px;
  }

  .labelInput {
    width: 140px;
  }

  .searchButton {
    margin: 21px 5px;
  }

  .accountTable {
    margin: 20px 3%;
    border: 1px;
    width: 94%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }

  .content {
    margin: 25px;
    background: rgba(249, 251, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(233, 236, 243, 1);
    padding: 29px 26px 29px 29px;
    color: #8c8c8c;

    p {
      margin-top: 7px;
    }

    .first {
      margin-top: 0px;
    }

    .type {
      padding-left: 20px;
    }

    .title {
      color: #00c1de;
    }
  }

  .addBtn {
    width: 83px;
    height: 35px;
    margin-top: 5px;
    margin-bottom: 10px;
    border-radius: 4px;
    float: left;
    margin-left: 3%;
    padding: 3px;
    border-color: #00c1de;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/groupAccounts/index.vue